<nav
  class="hidden md:flex w-full flex-wrap items-center gap-x-6 gap-y-2 md:justify-center xl:justify-start"
>
  @for (item of desktopNavigationItems(); track item.routerLink) {
  <lib-nav-desktop-menu-link [config]="item" />
  } @if (hasPersonnelDropdownItems()) {
  <lib-personel-dropdown
    [items]="personnelDropdownItems()"
    [isOpen]="isPersonelDropdownOpen()"
    (toggleClicked)="togglePersonelDropdown()"
    (navigate)="navigateToRoute($event)"
  />
  } @if (hasReferralsDropdownItems()) {
  <lib-referrals-dropdown
    [items]="referralsDropdownItems()"
    [isOpen]="isReferralsDropdownOpen()"
    (toggleClicked)="toggleReferralsDropdown()"
    (navigate)="navigateToRoute($event)"
  />
  } @if (hasSetupDropdownItems()) {
  <lib-setup-dropdown
    [items]="setupDropdownItems()"
    [isOpen]="isSetupDropdownOpen()"
    (toggleClicked)="toggleSetupDropdown()"
    (navigate)="navigateToRoute($event)"
  />
  } @if (canOpenAttendanceTerminal()) {
  <a
    href="/expert-kiosk/attendance"
    target="_blank"
    class="inline-flex h-9 items-center justify-center rounded-md bg-orange-700 px-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-orange-800 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 focus:ring-offset-gray-900"
  >
    Open Terminal
  </a>
  }
</nav>
